import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

// import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';

import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useMsalAuthentication } from "@azure/msal-react";
import { InteractionType, InteractionRequiredAuthError } from '@azure/msal-browser';

import Loading from './Shared/Loading';




import './WelcomePage.scss';





function WsLoginPage() {

  const request = {
    // loginHint: 'name@example.com,
    scopes: [ 'User.Read' ],
    // state: `redirect=${window.location.href}`
  };

  const { login, result, error } = useMsalAuthentication(InteractionType.Silent, request);

  useEffect(() => {
    if (error instanceof InteractionRequiredAuthError) {
      login(InteractionType.Redirect, request);
    }
  }, [ error ]);

  const { accounts } = useMsal();

  // console.log('RESULT');
  // console.log(result);
  // console.log('ACCOUNTS');
  // console.log(accounts);

  return (<Loading />);
}




export {
  WsLoginPage
};
